// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"e00751c8","453":"926f0775"}[chunkId] + ".chunk.js";
};